import {
  GET_SPECIALITY_BY_MONTH_REQUEST,
  GET_SPECIALITY_BY_MONTH_SUCCESS,
  GET_SPECIALITY_BY_MONTH_ERROR
} from "../actions/types";

export const SpecialityByMonth = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SPECIALITY_BY_MONTH_REQUEST:
      return {
        loading: true,
      };
    case GET_SPECIALITY_BY_MONTH_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_SPECIALITY_BY_MONTH_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
